import { toPattern } from "vanilla-masker";

type Patterns = "phone" | "cep" | "document";

const patterns = {
  phone: ["(99) 9999-9999", "(99) 9 9999-9999"],
  // CPF numérico | CNPJ: 12 alfanuméricos (S) + 2 dígitos verificadores (9)
  document: ["999.999.999-99", "SS.SSS.SSS/SSSS-99"],
  cep: "99999-999",
};

export const unMasked = (value: string) =>
  value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const getDocumentPatternIndex = (value: string) => {
  const cleaned = unMasked(value);
  const hasLetter = /[A-Z]/.test(cleaned);
  return cleaned.length > 11 || hasLetter ? 1 : 0;
};

export const masked = (value = "", pattern: Patterns) => {
  let maskedValue = "";

  if (pattern === "phone") {
    const size = value.replace(/\D/g, "").length > 10 ? 1 : 0;
    maskedValue = toPattern(value, patterns[pattern][size]);
  }

  if (pattern === "document") {
    const normalized = value.toUpperCase();
    const size = getDocumentPatternIndex(normalized);
    maskedValue = toPattern(normalized, patterns[pattern][size]);
  }

  if (pattern === "cep") return toPattern(value, patterns.cep);

  return maskedValue;
};
